import { User } from '@fable/types'

export const isSelfPlusUser = (user: User | null) => {
  const hasCustomGoals = user?.subscription?.features.includes('custom_goals')
  const hasAdvancedStats =
    user?.subscription?.features.includes('advanced_stats')

  return !!(hasCustomGoals && hasAdvancedStats)
}

export const isOtherPlusUser = (user: User | null) => {
  return !!user?.badges?.includes('fable_friends')
}
